import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=e772b5b6&"
import script from "./LanguageSwitch.vue?vue&type=script&lang=ts&"
export * from "./LanguageSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports